import React, { Component } from "react";
import StepWizzard from "react-step-wizard/dist/react-step-wizard.min";
import Prerequisites from "./Prerequisites";
import SelectAmount from "./SelectAmount";
import PreAuthorization from "./PreAuthorization";
import Confirm from "./Confirm";
import Outcome from "./Outcome";
import Nav from "./Nav";
import Disclaimer from "./Disclaimer";
import TopInfo from "./TopInfo";

export default class Wizzard extends Component {
  render() {
    return (
      <div>
        <TopInfo/>
        <StepWizzard nav={<Nav />} isHashEnabled={false}>
          <Prerequisites {...this.props} />
          <Disclaimer {...this.props}/>
          <SelectAmount {...this.props} />
          <PreAuthorization {...this.props} />
          <Confirm {...this.props} />
          <Outcome {...this.props} />
        </StepWizzard>
      </div>
    );
  }
}
